import {
  FETCH_PM_IWO_LIST_REQUEST,
  FETCH_PM_IWO_LIST_SUCCESS,
  FETCH_PM_IWO_LIST_FAILURE,
  INSERT_PM_FRAME_REQUEST,
  INSERT_PM_FRAME_SUCCESS,
  INSERT_PM_FRAME_FAILURE,
  FETCH_PM_FRAME_LIST_REQUEST,
  FETCH_PM_FRAME_LIST_SUCCESS,
  FETCH_PM_FRAME_LIST_FAILURE,
  INSERT_PM_DAILY_REMARK_REQUEST,
  INSERT_PM_DAILY_REMARK_SUCCESS,
  INSERT_PM_DAILY_REMARK_FAILURE,
  UPDATE_PM_COMPLETION_REQUEST,
  UPDATE_PM_COMPLETION_SUCCESS,
  UPDATE_PM_COMPLETION_FAILURE,
  UPDATE_PM_FRAME_REQUEST,
  UPDATE_PM_FRAME_SUCCESS,
  UPDATE_PM_FRAME_FAILURE,
  FETCH_PM_DELAY_REASONS_REQUEST,
  FETCH_PM_DELAY_REASONS_SUCCESS,
  FETCH_PM_DELAY_REASONS_FAILURE,
  DELETE_PM_FRAME_REQUEST,
  DELETE_PM_FRAME_SUCCESS,
  DELETE_PM_FRAME_FAILURE,
  FETCH_PM_IWO_FRAMES_REQUEST,
  FETCH_PM_IWO_FRAMES_SUCCESS,
  FETCH_PM_IWO_FRAMES_FAILURE,
  FETCH_PM_PART_WEIGHTS_REQUEST,
  FETCH_PM_PART_WEIGHTS_SUCCESS,
  FETCH_PM_PART_WEIGHTS_FAILURE,
  SAVE_PM_PART_WEIGHTS_REQUEST,
  SAVE_PM_PART_WEIGHTS_SUCCESS,
  SAVE_PM_PART_WEIGHTS_FAILURE,
  FETCH_PM_FRAMES_REQUEST,
  FETCH_PM_FRAMES_SUCCESS,
  FETCH_PM_FRAMES_FAILURE,
  FETCH_PM_DAILY_REMARKS_REQUEST,
  FETCH_PM_DAILY_REMARKS_SUCCESS,
  FETCH_PM_DAILY_REMARKS_FAILURE,
} from "../constants/ProductionMonitorConstants";

import ProductionMonitorService from "../service/ProductionMonitorService";

// Backend sends the error text in Result (e.g. StatusCode 409, Result: "Part No already exists for this IWO: 286")
const apiMessage = (data) =>
  data?.Message ||
  (typeof data?.Result === "string" && data.Result) ||
  data?.message ||
  "";

// Fetch IWO list for the IWO dropdown
export const fetchPmIwoList = () => async (dispatch) => {
  try {
    dispatch({ type: FETCH_PM_IWO_LIST_REQUEST });

    const response = await ProductionMonitorService.GetIwoList();

    dispatch({
      type: FETCH_PM_IWO_LIST_SUCCESS,
      payload: response.data.Data,
    });
  } catch (error) {
    dispatch({
      type: FETCH_PM_IWO_LIST_FAILURE,
      payload:
        apiMessage(error.response?.data) ||
        error.message ||
        "Failed to fetch IWO list",
    });
  }
};

export const insertPmFrame = (payload) => async (dispatch) => {
  try {
    dispatch({ type: INSERT_PM_FRAME_REQUEST });

    const response = await ProductionMonitorService.InsertFrame(payload);
    const data = response?.data;

    if ((data?.StatusCode && data.StatusCode !== 200) || data?.IsSuccess === false) {
      const message = apiMessage(data) || "Failed to insert frame";
      dispatch({ type: INSERT_PM_FRAME_FAILURE, payload: message });
      return { success: false, message };
    }

    dispatch({ type: INSERT_PM_FRAME_SUCCESS, payload: data });
    return { success: true, data };
  } catch (error) {
    const message =
      apiMessage(error.response?.data) ||
      error.message ||
      "Failed to insert frame";

    dispatch({ type: INSERT_PM_FRAME_FAILURE, payload: message });
    return { success: false, message };
  }
};

// Fetch all frames (with parts + daily remarks) for the Daily Remark page
export const fetchPmFrameList = () => async (dispatch) => {
  try {
    dispatch({ type: FETCH_PM_FRAME_LIST_REQUEST });

    const response = await ProductionMonitorService.GetFrameDetails();

    dispatch({
      type: FETCH_PM_FRAME_LIST_SUCCESS,
      payload: response.data.Data,
    });
  } catch (error) {
    dispatch({
      type: FETCH_PM_FRAME_LIST_FAILURE,
      payload:
        apiMessage(error.response?.data) ||
        error.message ||
        "Failed to fetch frame list",
    });
  }
};

// Insert daily remark for a frame
// returns { success: true } or { success: false, message }
export const insertPmDailyRemark = (payload) => async (dispatch) => {
  try {
    dispatch({ type: INSERT_PM_DAILY_REMARK_REQUEST });

    const response = await ProductionMonitorService.InsertDailyRemark(payload);
    const data = response?.data;

    // API returned a non-200 StatusCode or IsSuccess = false
    if ((data?.StatusCode && data.StatusCode !== 200) || data?.IsSuccess === false) {
      const message = apiMessage(data) || "Failed to save daily remark";
      dispatch({ type: INSERT_PM_DAILY_REMARK_FAILURE, payload: message });
      return { success: false, message };
    }

    dispatch({ type: INSERT_PM_DAILY_REMARK_SUCCESS, payload: data });
    return { success: true, data };
  } catch (error) {
    const message =
      apiMessage(error.response?.data) ||
      error.message ||
      "Failed to save daily remark";

    dispatch({ type: INSERT_PM_DAILY_REMARK_FAILURE, payload: message });
    return { success: false, message };
  }
};

// Update physical completion (%) of a frame
// returns { success: true } or { success: false, message }
export const updatePmPhysicalCompletion = (payload) => async (dispatch) => {
  try {
    dispatch({ type: UPDATE_PM_COMPLETION_REQUEST });

    const response = await ProductionMonitorService.UpdatePhysicalCompletion(payload);
    const data = response?.data;

    // API returned a non-200 StatusCode or IsSuccess = false
    if ((data?.StatusCode && data.StatusCode !== 200) || data?.IsSuccess === false) {
      const message = apiMessage(data) || "Failed to update physical completion";
      dispatch({ type: UPDATE_PM_COMPLETION_FAILURE, payload: message });
      return { success: false, message };
    }

    dispatch({ type: UPDATE_PM_COMPLETION_SUCCESS, payload: data });
    return { success: true, data };
  } catch (error) {
    const message =
      apiMessage(error.response?.data) ||
      error.message ||
      "Failed to update physical completion";

    dispatch({ type: UPDATE_PM_COMPLETION_FAILURE, payload: message });
    return { success: false, message };
  }
};

// Update a frame (only changed fields are in the payload)
export const updatePmFrame = (payload) => async (dispatch) => {
  try {
    dispatch({ type: UPDATE_PM_FRAME_REQUEST });

    const response = await ProductionMonitorService.UpdateFrame(payload);
    const data = response?.data;

    // API returned a non-200 StatusCode or IsSuccess = false
    if ((data?.StatusCode && data.StatusCode !== 200) || data?.IsSuccess === false) {
      const message = apiMessage(data) || "Failed to update frame";
      dispatch({ type: UPDATE_PM_FRAME_FAILURE, payload: message });
      return { success: false, message };
    }

    dispatch({ type: UPDATE_PM_FRAME_SUCCESS, payload: data });
    return { success: true, data };
  } catch (error) {
    const message =
      apiMessage(error.response?.data) ||
      error.message ||
      "Failed to update frame";

    dispatch({ type: UPDATE_PM_FRAME_FAILURE, payload: message });
    return { success: false, message };
  }
};

// Delay reasons for daily remark (CDL + DTS dropdowns)
export const fetchPmDelayReasons = () => async (dispatch) => {
  try {
    dispatch({ type: FETCH_PM_DELAY_REASONS_REQUEST });

    const response = await ProductionMonitorService.GetDelayReasons();

    dispatch({
      type: FETCH_PM_DELAY_REASONS_SUCCESS,
      payload: response.data.Data,
    });
  } catch (error) {
    dispatch({
      type: FETCH_PM_DELAY_REASONS_FAILURE,
      payload:
        apiMessage(error.response?.data) ||
        error.message ||
        "Failed to fetch delay reasons",
    });
  }
};

// Delete a frame (wrongly entered)
export const deletePmFrame = (payload) => async (dispatch) => {
  try {
    dispatch({ type: DELETE_PM_FRAME_REQUEST });

    const response = await ProductionMonitorService.DeleteFrame(payload);
    const data = response?.data;

    // API returned a non-200 StatusCode or IsSuccess = false
    if ((data?.StatusCode && data.StatusCode !== 200) || data?.IsSuccess === false) {
      const message = apiMessage(data) || "Failed to delete frame";
      dispatch({ type: DELETE_PM_FRAME_FAILURE, payload: message });
      return { success: false, message };
    }

    dispatch({ type: DELETE_PM_FRAME_SUCCESS, payload: payload.frameId });
    return { success: true, data };
  } catch (error) {
    const message =
      apiMessage(error.response?.data) ||
      error.message ||
      "Failed to delete frame";

    dispatch({ type: DELETE_PM_FRAME_FAILURE, payload: message });
    return { success: false, message };
  }
};

// Frames of the given IWO(s) - for the frame count / completed summary in Production
// (one GetFrameDetails?iwoNo=xx call per IWO)
export const fetchPmIwoFrames = (iwoNos = []) => async (dispatch) => {
  try {
    dispatch({ type: FETCH_PM_IWO_FRAMES_REQUEST });

    const responses = await Promise.all(iwoNos.map((iwoNo) => ProductionMonitorService.GetFrameDetails(iwoNo)));
    const frames = responses.flatMap((r) => r?.data?.Data || []);

    dispatch({ type: FETCH_PM_IWO_FRAMES_SUCCESS, payload: frames });
  } catch (error) {
    dispatch({
      type: FETCH_PM_IWO_FRAMES_FAILURE,
      payload:
        apiMessage(error.response?.data) ||
        error.message ||
        "Failed to fetch frames",
    });
  }
};

// Part weights of one IWO (GetPartWeights?iwoNo=xx)
export const fetchPmPartWeights = (iwoNo) => async (dispatch) => {
  try {
    dispatch({ type: FETCH_PM_PART_WEIGHTS_REQUEST, payload: String(iwoNo) });

    const response = await ProductionMonitorService.GetPartWeights(iwoNo);

    dispatch({
      type: FETCH_PM_PART_WEIGHTS_SUCCESS,
      payload: { iwoNo: String(iwoNo), parts: response.data.Data || [] },
    });
  } catch (error) {
    dispatch({
      type: FETCH_PM_PART_WEIGHTS_FAILURE,
      payload:
        apiMessage(error.response?.data) ||
        error.message ||
        "Failed to fetch part weights",
    });
  }
};

// A big part list (1000+ parts) is sent in batches, so the form data stays small enough for the server
const PART_BATCH_SIZE = 300;

// Save part weights: newParts -> InsertPartWeights, changedParts -> UpdatePartWeights
// returns { success, message, inserted, updated }
export const savePmPartWeights = ({ iwoNo, newParts = [], changedParts = [], userId }) => async (dispatch) => {
  let inserted = 0;
  let updated = 0;
  try {
    dispatch({ type: SAVE_PM_PART_WEIGHTS_REQUEST });

    const check = (data, fallback) => {
      if ((data?.StatusCode && data.StatusCode !== 200) || data?.IsSuccess === false) {
        throw new Error(apiMessage(data) || fallback);
      }
    };

    // parts the server says already exist -> they are updated instead of inserted
    const toUpdate = [...changedParts];

    for (let i = 0; i < newParts.length; i += PART_BATCH_SIZE) {
      let parts = newParts.slice(i, i + PART_BATCH_SIZE);
      while (parts.length > 0) {
        let data;
        try {
          // eslint-disable-next-line no-await-in-loop
          const response = await ProductionMonitorService.InsertPartWeights({ iwoNo, createdBy: userId, parts });
          data = response?.data;
        } catch (err) {
          data = err.response?.data;
          if (!data) throw err;
        }

        const failed = (data?.StatusCode && data.StatusCode !== 200) || data?.IsSuccess === false;
        if (!failed) {
          inserted += parts.length;
          break;
        }

        // "Part No already exists for this IWO (use update): 3, 4, 5"
        const msg = apiMessage(data) || "";
        const m = /already exists[^:]*:\s*(.+)$/i.exec(msg);
        const existing = m ? new Set(m[1].split(",").map((x) => x.trim()).filter(Boolean)) : null;
        const already = existing ? parts.filter((p) => existing.has(String(p.partNo))) : [];
        if (already.length === 0) throw new Error(msg || "Failed to insert part weights"); // a different error

        toUpdate.push(...already); // update their weight instead
        parts = parts.filter((p) => !existing.has(String(p.partNo))); // insert the rest again
      }
    }

    for (let i = 0; i < toUpdate.length; i += PART_BATCH_SIZE) {
      const parts = toUpdate.slice(i, i + PART_BATCH_SIZE);
      // eslint-disable-next-line no-await-in-loop
      const response = await ProductionMonitorService.UpdatePartWeights({ iwoNo, updatedBy: userId, parts });
      check(response?.data, "Failed to update part weights");
      updated += parts.length;
    }

    dispatch({ type: SAVE_PM_PART_WEIGHTS_SUCCESS });
    return { success: true, inserted, updated };
  } catch (error) {
    let message =
      apiMessage(error.response?.data) ||
      error.message ||
      "Failed to save part weights";
    if (inserted || updated) message += ` (${inserted} inserted, ${updated} updated before the error)`;

    dispatch({ type: SAVE_PM_PART_WEIGHTS_FAILURE, payload: message });
    return { success: false, message, inserted, updated };
  }
};

// All frames (GetFrames) - Remark History IWO / component / frame filters
export const fetchPmFrames = () => async (dispatch) => {
  try {
    dispatch({ type: FETCH_PM_FRAMES_REQUEST });

    const response = await ProductionMonitorService.GetFrames();

    dispatch({
      type: FETCH_PM_FRAMES_SUCCESS,
      payload: response.data.Data,
    });
  } catch (error) {
    dispatch({
      type: FETCH_PM_FRAMES_FAILURE,
      payload:
        apiMessage(error.response?.data) ||
        error.message ||
        "Failed to fetch frames",
    });
  }
};

// Daily remarks of an IWO, optional frameId / workDate (GetDailyRemarks)
export const fetchPmDailyRemarks = ({ iwoNo, frameId, workDate } = {}) => async (dispatch) => {
  const key = `${iwoNo || ""}|${frameId || ""}|${workDate || ""}`; // to ignore an older answer
  try {
    dispatch({ type: FETCH_PM_DAILY_REMARKS_REQUEST, payload: key });

    const response = await ProductionMonitorService.GetDailyRemarks({ iwoNo, frameId, workDate });

    dispatch({
      type: FETCH_PM_DAILY_REMARKS_SUCCESS,
      payload: { key, remarks: response.data.Data || [] },
    });
  } catch (error) {
    dispatch({
      type: FETCH_PM_DAILY_REMARKS_FAILURE,
      payload: {
        key,
        message:
          apiMessage(error.response?.data) ||
          error.message ||
          "Failed to fetch daily remarks",
      },
    });
  }
};


export const loadPmPartWeights = (iwoNo) => async () => {
  try {
    const response = await ProductionMonitorService.GetPartWeights(iwoNo);
    return { success: true, data: response.data.Data || [] };
  } catch (error) {
    return {
      success: false,
      data: [],
      message: apiMessage(error.response?.data) || error.message || "Failed to fetch part weights",
    };
  }
};